export const COMMENT_STATUS = {
  PENDING: 0,
  CONFIRMED: 1,
  REJECTED: 2,
} as const;
